<template>
  <order-complete-layout>
    <compare-power-card v-if="order_status === 'complete'">

      <cp-notice type="positive" clear header="Your order is complete" header_class="text-250"></cp-notice>


      <!--      <q-card class="bg-grey-2 more-rounded-borders q-pa-xs q-mb-md text-100">-->
      <q-card-section>

        <q-markup-table wrap-cells>
          <tbody>
          <tr>
            <td> Compare Power Order Number:</td>
            <td> {{ order.order_number }}</td>
          </tr>
          <tr>
            <td>Order Status:</td>
            <td>Complete: {{ format_date(order.last_modified_date) }}</td>
          </tr>
          <tr>
            <td>Requested Service Start Date:</td>
            <td> {{ get_start_date() }}
            </td>
          </tr>

          <tr v-for="order_key in order.order_keys?.filter(x=> x.type !== 'payment_confirmation')">
            <td> {{ order.brand }} {{ order_key.friendly_name }}:</td>
            <td>
              {{ order_key.value }}
            </td>
          </tr>
          <tr v-if="order.validated_make_payment?.value?.payment_transaction_id">
            <td> {{ order.brand }}
              {{ order.selected_plan?.value?.product?.is_pre_pay ? 'Pre-Payment' : 'Deposit Payment' }} Amount:
            </td>
            <td> ${{ order.payment_request.payment_amount.toFixed(2) }}</td>
          </tr>
          <tr v-for="order_key in order.order_keys?.filter(x=> x.type === 'payment_confirmation')">
            <td> {{ order.brand }} {{ order_key.friendly_name }}:</td>
            <td>
              {{ order_key.value }}
            </td>
          </tr>
          </tbody>
        </q-markup-table>

      </q-card-section>
      <!--      </q-card>-->

      <q-card-section class="text-blue-grey-8 q-mb-md">

        <div class="q-mb-xl">
          <div class="text-125 text-bold q-mb-md"> Congratulations!</div>
          <div class="text-100 q-mb-sm">
            Your new electric service has been confirmed. No further action is required from you at this time.
          </div>
          <div class="text-100" v-if="!order.request.options?.move_in">
            There is no need to contact your current Retail Electric Provider (REP) about cancelling your service with
            them. This is all handled automatically without any interruption to your electric service.
          </div>
          <div class="text-100" v-else>
            There is no need to contact {{ order.selected_plan.value.product.brand.name }} about your order. They are
            already hard at work putting everything into place in time for your big move, and they will contact you if
            anything unexpected arises.
          </div>
        </div>

        <div class="text-125 text-bold q-mb-lg">
          What to expect next:
        </div>

        <ul class="text-100 q-gutter-y-sm">
          <li>
            You will receive a confirmation email from ComparePower with all of your order details.
          </li>
          <li v-if="order.request.options?.move_in">
            {{ order.selected_plan.value.product.brand.name }} will begin servicing your address on
            {{ format_date(order.request.selected_start_date, true) }}.
          </li>
          <li v-if="!order.request.options?.move_in">
            You will receive a postcard from ERCOT at your service address confirming your change in providers. This
            postcard is
            a consumer safety practice to ensure you were the one who requested the enrollment. No action is required
            unless
            something on that card is incorrect
          </li>
          <li>
            You will receive a welcome email from {{ order.selected_plan.value.product.brand.name }} once they have
            started servicing your address.
          </li>
        </ul>

      </q-card-section>

      <q-card-actions></q-card-actions>
    </compare-power-card>
  </order-complete-layout>
</template>

<script>
import Orders                 from "src/composables/Orders";
import ComparePowerCardHeader from "components/ComparePowerCardHeader";
import ComparePowerCard       from "components/ComparePowerCard";
import OtherServices          from "components/order/OtherServices";
import OrderCompleteLayout    from "layouts/OrderCompleteLayout";
import Analytics              from "src/composables/Analytics";
import { onMounted }          from "vue";
import { DateTime }           from "luxon";
import Utilities              from "src/composables/Utilities";
import CpNotice               from "components/order/CpNotice";
import SelectedPlan           from "src/composables/SelectedPlan";

export default {
  name: "Confirmation",
  components: { CpNotice, OrderCompleteLayout, OtherServices, ComparePowerCard, ComparePowerCardHeader },
  setup() {
    const { order_status, order, mark_complete_page_viewed } = Orders();
    const { log_event } = Analytics();
    const { get_start_date_string, format_date, plan_to_ecommerce } = Utilities();


    onMounted(() => {

      if (!order.value.complete_page_viewed) {
        log_event({
          name: 'purchase',
          keep_name: true,
          ecommerce: {
            transaction_id: order.value._id,
            items: [
              plan_to_ecommerce({
                plan: order.value?.selected_plan?.value,
                sort_index: order.value?.selected_plan?.value?.sort_index,
                list_id: order.value?.selected_plan?.value?.list_id
              })
            ]
          }
        })
        const pre_pay_paid = order.value.selected_plan.value.product.is_pre_pay
        const dep_paid = !!order.value.deposit_required
        log_event({
          name: 'co_order_complete',
          order: { ...order.value },
          order_complete_page_type: {
            pre_pay_paid,
            dep_paid,
            dep_none: !dep_paid
          },
          show_shopper_approved: !dep_paid
        })

        mark_complete_page_viewed({ order_id: order.value._id })
      }
    })

    if (order.value.selected_plan?.value?.product?.is_pre_pay) {
      for (const key of order.value.order_keys) {
        key.friendly_name = key.friendly_name.replace(/deposit payment/ig, 'Pre-Payment')
      }
    }

    const get_start_date = () => {
      const action = order.value?.request?.options?.move_in ? 'Move' : order.value.request.selected_start_date ? 'Switch' : 'ASAP';
      return get_start_date_string(action, order.value.request.selected_start_date);
    }

    return {
      order_status,
      order,
      format_date,
      get_start_date
    }
  }
}
</script>

<style lang="sass" scoped>

@media (max-width: $breakpoint-xs-max)
  .q-table tbody td
    font-size: 14px


@media (min-width: $breakpoint-sm-min)
  .q-table tbody td
    font-size: 18px

</style>
